import React from "react";
import {ComponentPropsFromRoute} from "../../routers/routers";
import {ExtendedSwitch} from "../core/router/extended-switch/extended.switch";

export const Containers: React.FC<ComponentPropsFromRoute> = ({routeChildren}) => {
    return <ExtendedSwitch routers={routeChildren!} />
}